const ERROR_CODES = {
    AFF_005: "AFF-005",
    AFF_019: "AFF-019",
    AFF_009: "AFF-009"
};

const API_ERRORS_MAP = {
    [ERROR_CODES.AFF_005]: "El email ingresado ya está en uso con otro operador. Para poder usar este email desvincula la cuenta o utiliza otro email",
    [ERROR_CODES.AFF_019]: "Lo sentimos. No tienes acceso a Fanatiz con tu paquete de suscripción",
    [ERROR_CODES.AFF_009]: "No hemos podido validar tus datos. Por favor, verifica tu email y contraseña e inténtalo nuevamente."
};

const DEFAULT_ERROR_MESSAGE = "¡Ups! Algo salió mal. Por favor, inténtalo de nuevo más tarde."

export {
    ERROR_CODES,
    API_ERRORS_MAP,
    DEFAULT_ERROR_MESSAGE
};